<mat-card class="login-form">

  <mat-card-header>
    <h1>TASTI-GRID</h1>
  </mat-card-header>

  <mat-card-subtitle>
    <p>
      Welcome to TASTI-GRID, an interactive tool that enables users to explore historical electric outage data to
      better understand the state of the grid and inform grid resilience investments. TASTI-GRID is a technical
      assistance offering sponsored by the U.S. Department of Energy’s Grid Deployment Office in partnership with
      Oak Ridge National Laboratory.
    </p>
    <p><a routerLink="/login/account-request">Request account</a></p>
  </mat-card-subtitle>

  <mat-card-content>

    <form [formGroup]="loginGroup">
      <mat-form-field appearance="outline">
        <mat-label>Username or Email</mat-label>
        <input matInput type="text" placeholder="Username or Email" formControlName="username"/>
        <mat-error>
          @if (loginGroup.get('username')?.hasError('required')) {
            <span>
              A username or email is required.
            </span>
          }
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" placeholder="password" formControlName="password">
        <mat-error>
          @if (loginGroup.get('password')?.hasError('required')) {
            <span>
              A password is required.
            </span>
          }
        </mat-error>
      </mat-form-field>

      <button class="wide"
        mat-flat-button
      [disabled]="loginGroup.invalid || isLoading" color="primary" (click)="login()">
        <span class="login-button-content">
          @if (isLoading) {
            <mat-progress-spinner
              class="login-spinner"
              mode="indeterminate"
              diameter="18"
              strokeWidth="3"
              aria-hidden="true"
            ></mat-progress-spinner>
            <span>Logging in...</span>
          } @else {
            <span>Login</span>
          }
        </span>
      </button>
    </form>
  </mat-card-content>

  <div class="password-links">
    <p><a routerLink="/login/forgot-password" class="forgot-pw">Forgot Password?</a></p>
  </div>

  @if (errorMessage | async; as message) {
    <mat-card-footer>
      <span class="error-message">{{message}}</span>
    </mat-card-footer>
  }



</mat-card>
